module.exports = __webpack_public_path__ + "img/9791186921050.126d69af.jpg";